import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_368: DocMigration = {
  maxSchemaVersion: "0.0.368",
  description: "Set invertFilter to true for existing view template overrides",
  apply(json: any) {
    for (const id in json.viewTemplateOverrides) {
      const viewTemplateOverride = json.viewTemplateOverrides[id];
      viewTemplateOverride.invertFilter = true;

      if (viewTemplateOverride.categories === undefined) {
        viewTemplateOverride.categories = [];
      }
    }
    return json;
  },
};

export default migration_0_0_368;
